import { Col, Row } from "react-bootstrap";
import { Loader } from "../../components/common/progress/Loader";
import { usePlugin } from "../../components/plugins/contexts/PluginContext";
import { DeleteAction } from "../../components/plugins/models/DeleteAction";
import { SideNavbar } from "../../components/plugins/SideNavbar";
import { useVersion } from "../../components/plugins/contexts/VersionContext";
import { VersionDetailsForm } from "../../components/plugins/VersionDetailsForm";
import { DraftVersionButtonGroup } from "../../components/plugins/DraftVersionButtonGroup";
import { DeleteVersionButtonGroup } from "../../components/plugins/DeleteVersionButtonGroup";
import { VersionDetailsPartial } from "../../components/plugins/VersionDetailsPartial";
import { PluginVersionTabs } from "../../components/plugins/PluginVersionTabs";
import { useEffect } from "react";
import { Status } from "../../components/plugins/models/Status";
import { useNavigate } from "react-router-dom";
import { NotFound } from "../NotFound";
import { routes } from "../../main/routes";
import { DownloadVersionButtonGroup } from "../../components/plugins/DownloadVersionButtonGroup";

export const DraftVersion = () => {
  const { isLoading, pluginDetails: plugin } = usePlugin();
  const { version } = useVersion();
  const navigate = useNavigate();
  const draftVersion = version?.unpublishedPluginVersion ?? version;
  const hasUrl = !!version?.downloadDetails?.downloadUrl;

  useEffect(() => {
    if (draftVersion && draftVersion.status !== Status.InComplete) {
      navigate(routes.versions.update(plugin.id, version.versionId, plugin.status));
    }
  }, [draftVersion]);

  if (isLoading) return <Loader />;
  if (!draftVersion) return <NotFound />;

  return (
    <VersionDetailsForm version={draftVersion}>
      <Row>
        <Col xs={12} lg={4} style={{ borderRight: "1px solid lightgray" }}>
          <SideNavbar plugin={plugin} />
        </Col>
        <Col xs={12} lg={8}>
          <PluginVersionTabs />
          <VersionDetailsPartial enableFileUpload />
          <div className="d-flex justify-content-between mb-2">
            <div className="d-flex">
              <DraftVersionButtonGroup />
              <DeleteVersionButtonGroup version={draftVersion} futureInstructions={DeleteAction.One} />
            </div>
            {hasUrl && <DownloadVersionButtonGroup />}
          </div>
        </Col>
      </Row>
    </VersionDetailsForm>
  );
};
